import React from 'react';

const MerryChristmasComponent = () => (
  <iframe
    src="/felicitacion/index.html"
    title="vista-merry-christmas"
    style={{ width: '100%', height: '100vh', border: 'none' }}
  />
);

export default MerryChristmasComponent;
